<template>
  <b-overlay :show="busy" rounded="sm">
    <!-- {{ search.selected }}<br /> -->
    <!-- {{ item }} -->
    <b-card class="border-none py-0 mb-0 no-margin px-1">
      <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="text-primary mr-1"></i>
        {{ item.confirmationno }}
        <span class="text-warning"
          >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
        >
      </b-card-header>
      <b-card-body class="py-0">
        <b-row>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              :label="$helpers.requiredlabel(requirement, 'Driver')"
              :class="
                $helpers.requiredlabel(requirement, 'Driver').slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-for="driver"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.driver"
                  placeholder="Enter driver"
                  size="sm"
                  trim
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.driver = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label-cols="12"
              :label="$helpers.requiredlabel(requirement, 'Client SL A/C')"
              :class="
                $helpers
                  .requiredlabel(requirement, 'Client SL A/C')
                  .slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-size="sm"
            >
              <treeselect
                placeholder="Select slac..."
                searchPromptText="Type at least 3 chars..."
                v-model="item.slac"
                :clearable="true"
                :async="true"
                :load-options="treeselect_loadSLAC"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
                :disabled="readonly"
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label-cols="12"
              :label="$helpers.requiredlabel(requirement, 'Event')"
              :class="
                $helpers.requiredlabel(requirement, 'Event').slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-size="sm"
            >
              <treeselect
                placeholder="Select event..."
                searchPromptText="Type at least 4 chars..."
                v-model="item.eventcode"
                :clearable="true"
                :async="true"
                :load-options="treeselect_loadEvent"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label="Your Ref / PO"
              label-for="yourref"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.yourref"
                  placeholder="Enter Your Ref / PO"
                  size="sm"
                  trim
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.yourref = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Booked" label-for="booked" label-cols="12">
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-datepicker
                    size="sm"
                    v-model="item.datebooked"
                    button-only
                    label-help=""
                    locale="en-GB"
                    hide-header
                    :disabled="readonly"
                  ></b-form-datepicker>
                </b-input-group-prepend>
                <b-form-input
                  size="sm"
                  id="date"
                  v-model="item.datebooked"
                  type="text"
                  placeholder="YYYY-MM-DD"
                  autocomplete="off"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.datebooked = null"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label-cols="12"
              :label="$helpers.requiredlabel(requirement, 'Supplier BL A/C')"
              :class="
                $helpers
                  .requiredlabel(requirement, 'Supplier BL A/C')
                  .slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-size="sm"
            >
              <treeselect
                placeholder="Select blac..."
                searchPromptText="Type at least 3 chars..."
                v-model="item.blac"
                :clearable="true"
                :async="true"
                :load-options="treeselect_loadBLAC"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
                :disabled="readonly"
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label="Local Phone No"
              label-for="blphone"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.blphone"
                  placeholder="Local Phone No"
                  size="sm"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.blphone = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label="Car Group"
              label-for="cargroup"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.cargroup"
                  placeholder="Enter car group"
                  size="sm"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.cargroup = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Car" label-for="car" label-cols="12">
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.car"
                  placeholder="Enter car"
                  size="sm"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.car = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label="Quoted Rate + Currency"
              label-for="quotedrate"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.quotedrate"
                  placeholder="Enter quoted rate"
                  size="sm"
                  lazy-formatter
                  :formatter="nocomma"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.quotedrate = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Voucher" label-for="voucher" label-cols="12">
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.voucher"
                  placeholder="Enter voucher"
                  size="sm"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.voucher = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group
              label="Conf No"
              label-for="confirmationno"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.confirmationno"
                  placeholder="Enter confirmation no"
                  size="sm"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.confirmationno = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" sm="6" lg="4" xl="3">
            <b-form-group
              :label="$helpers.requiredlabel(requirement, 'Pickup Date')"
              :class="
                $helpers
                  .requiredlabel(requirement, 'Pickup Date')
                  .slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-for="pickupdate"
              label-cols="12"
            >
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-datepicker
                    size="sm"
                    v-model="item.pickupdate"
                    button-only
                    label-help=""
                    locale="en-GB"
                    hide-header
                    :disabled="readonly"
                  ></b-form-datepicker>
                </b-input-group-prepend>
                <b-form-input
                  size="sm"
                  id="date"
                  v-model="item.pickupdate"
                  type="text"
                  placeholder="YYYY-MM-DD"
                  autocomplete="off"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.pickupdate = null"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" lg="4" xl="3">
            <b-form-group
              :label="$helpers.requiredlabel(requirement, 'Pickup Time')"
              :class="
                $helpers
                  .requiredlabel(requirement, 'Pickup Time')
                  .slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-for="pickuptime"
              label-cols="12"
            >
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-timepicker
                    size="sm"
                    v-model="item.pickuptime"
                    button-only
                    label-help=""
                    hide-header
                    :disabled="readonly"
                  ></b-form-timepicker>
                </b-input-group-prepend>
                <b-form-input
                  size="sm"
                  id="date"
                  v-model="item.pickuptime"
                  type="text"
                  placeholder="HH:MM"
                  autocomplete="off"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.pickuptime = null"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="12" lg="12" xl="6">
            <b-form-group
              :label="$helpers.requiredlabel(requirement, 'Pickup Location')"
              :class="
                $helpers
                  .requiredlabel(requirement, 'Pickup Location')
                  .slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-for="pickuplocation"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.pickuplocation"
                  placeholder="Enter pickup location"
                  size="sm"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.pickuplocation = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" lg="4" xl="3">
            <b-form-group
              :label="$helpers.requiredlabel(requirement, 'Dropoff Date')"
              :class="
                $helpers
                  .requiredlabel(requirement, 'Dropoff Date')
                  .slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-for="dropoffdate"
              label-cols="12"
            >
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-datepicker
                    size="sm"
                    v-model="item.dropoffdate"
                    button-only
                    locale="en-GB"
                    label-help=""
                    hide-header
                    :disabled="readonly"
                  ></b-form-datepicker>
                </b-input-group-prepend>
                <b-form-input
                  size="sm"
                  id="date"
                  v-model="item.dropoffdate"
                  type="text"
                  placeholder="YYYY-MM-DD"
                  autocomplete="off"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.dropoffdate = null"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" lg="4" xl="3">
            <b-form-group
              :label="$helpers.requiredlabel(requirement, 'Dropoff Time')"
              :class="
                $helpers
                  .requiredlabel(requirement, 'Dropoff Time')
                  .slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-for="dropofftime"
              label-cols="12"
            >
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-timepicker
                    size="sm"
                    v-model="item.dropofftime"
                    button-only
                    label-help=""
                    hide-header
                    :disabled="readonly"
                  ></b-form-timepicker>
                </b-input-group-prepend>
                <b-form-input
                  size="sm"
                  id="date"
                  v-model="item.dropofftime"
                  type="text"
                  placeholder="HH:MM"
                  autocomplete="off"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.dropofftime = null"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="12" lg="12" xl="6">
            <b-form-group
              :label="$helpers.requiredlabel(requirement, 'Dropoff Location')"
              :class="
                $helpers
                  .requiredlabel(requirement, 'Dropoff Location')
                  .slice(0, 1) == '*'
                  ? 'text-danger'
                  : ''
              "
              label-for="dropofflocation"
              label-cols="12"
            >
              <b-input-group>
                <b-form-input
                  type="text"
                  v-model="item.dropofflocation"
                  placeholder="Enter dropoff location"
                  size="sm"
                  :disabled="readonly"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.dropofflocation = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" sm="12">
            <b-form-group
              label="Voucher Notes"
              label-for="message"
              label-cols="12"
            >
              <b-form-textarea
                id="message"
                rows="8"
                v-model="item.message"
                placeholder="Voucher Notes"
                :disabled="readonly"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" sm="6" md="4" xl="3" v-if="idselected">
            <b-form-group label-cols="12" label="Status" label-size="sm">
              <treeselect
                placeholder="Select status..."
                v-model="item.status"
                :clearable="false"
                :options="status_options"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
                :disabled="readonly"
              >
                <!-- <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div> -->
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col v-if="item.id" cols="12" sm="6" md="4" xl="3">
            <b-form-group
              :disabled="item.invoiceno ? true : false"
              label-cols="12"
              label="Agent"
              label-size="sm"
            >
              <b-input-group>
                <b-form-input
                  v-model="item.agent"
                  :disabled="readonly"
                  placeholder="Agent"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    :disabled="readonly"
                    @click="item.agent = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-2"
          ><b-col
            ><span class="text-danger small">* Required</span></b-col
          ></b-row
        >
      </b-card-body>
      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left" cols="8">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="4">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
            <b-button
            :disabled="posted"
              squared
              size="sm"
              variant="primary"
              @click="saveit()"
              v-if="
                !item.invoiceno
                  ? true
                  : false || this.user.permissions.includes('cars.save')
              "
            >
              <i class="fa fa-check"></i>
              Save It
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "CarBookingsEdit",
  mounted() {
    this.item.agent = this.user.initials;
  },
  computed: {
    readonly() {
      if (this.user.rolename == "admin") {
        return false;
      } else {
        return this.item.invoiceno ? true : false;
      }
    },
    status_options() {
      switch (this.item.status) {
        case "CX":
        case "AA":
        case "ST":
          return [
            { id: "ST", label: "New" },
            { id: "AA", label: "On Hold" },
            { id: "CX", label: "Cancelled" },
          ];
          break;
        case "ID":
          return [
            { id: "ID", label: "Invoiced" },
            { id: "CX", label: "Cancelled" },
          ];
          break;
      }
    },
  },

  data() {
    return {
      busy: false,
      posted: false,
      message: "",
      requirement: {
        driver: "Driver",
        slac: "Client SL A/C",
        blac: "Supplier BL A/C",
        eventcode: "Event",
        pickupdate: "Pickup Date",
        pickuptime: "Pickup Time",
        pickuplocation: "Pickup Location",
        dropoffdate: "Dropoff Date",
        dropofftime: "Dropoff Time",
        dropofflocation: "Dropoff Location",
      },
      item: {
        id: null,
        driver: null,
        slac: null,
        datebooked: this.$moment().format("YYYY-MM-DD"),
        blac: null,
        cargroup: null,
        yourref: null,
        voucher: "E-VOUCHER",
        quotedrate: null,
        confirmationno: null,
        pickupdate: this.$moment().format("YYYY-MM-DD"),
        pickuptime: "12:00",
        pickuplocation: null,
        dropoffdate: this.$moment().format("YYYY-MM-DD"),
        dropofftime: "12:00",
        dropofflocation: null,
        message: null,
        invoiceno: null,
        status: null,
        agent: null,
      },
      options: {
        title: "Car Booking Edit",
        icon: "fa fa-car",
      },
    };
  },
  methods: {
    async loadDDL() {
      // console.log("loadDDL");
    },
    async load() {
      let variables = {
        id: this.idselected,
        dateformat: "YYYY-MM-DD",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query carbookings($id: String, $dateformat: String) {
              carbookings(id: $id, dateformat: $dateformat) {
                id
                driver
                slac
                eventcode
                datebooked
                blac
                blphone
                yourref
                cargroup
                car
                voucher
                quotedrate
                confirmationno
                pickupdate
                pickuptime
                pickuplocation
                dropoffdate
                dropofftime
                dropofflocation
                message
                agent
                invoiceno
                status
              }
            }
          `,
          variables,
        });

        if (response.data.carbookings.length > 0) {
          this.item = response.data.carbookings[0];
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      let row = this.cleanit(this.item);

      this.message = this.$helpers.mandatoryFields(
        {
          driver: "Driver",
          slac: "Client SL A/C",
          blac: "Supplier BL A/C",
          eventcode: "Event",
          pickupdate: "Pickup Date",
          pickuptime: "Pickup Time",
          pickuplocation: "Pickup Location",
          dropoffdate: "Dropoff Date",
          dropofftime: "Dropoff Time",
          dropofflocation: "Dropoff Location",
        },
        row
      );
      if (this.message.length > 0) {
        return;
      }

      if (row.slac == "BBC3") {
        if (!row.yourref) {
          this.message =
            "<span class='text-danger'>Your Ref/PO" + " is required!</span>";
          return;
        } else {
          let yrparts = row.yourref.split("*");
          console.log(yrparts, row.yourref);
          if (yrparts.length == 1) {
            this.message =
              "<span class='text-danger'>Your Ref/PO" +
              " needs a Booker Name (e.g. " +
              row.yourref +
              "*RE)</span>";
            return;
          }
        }
      }

      this.busy = true;

      let variables = { id: this.idselected, row };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation savecar($id: String, $row: Carbooking_input) {
              savecar(id: $id, row: $row) {
                id
                driver
                slac
                eventcode
                datebooked
                blac
                blphone
                yourref
                cargroup
                car
                voucher
                quotedrate
                confirmationno
                pickupdate
                pickuptime
                pickuplocation
                dropoffdate
                dropofftime
                dropofflocation
                message
                agent
                invoiceno
                status
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
        this.posted = true
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
  },
};
</script>

<style>
.card {
  text-align: left !important;
}
</style>